import { QueryField, QueryRule } from '../../../../../types/QueryBuilder';

export interface RowProps {
    field: QueryField;
    rule: QueryRule | undefined;
    onUpdateField: (fieldName: string, data: Partial<QueryRule>) => void;
}

export interface FieldRowProps extends RowProps {
    pairedField: QueryField | undefined;
    pairedRule: QueryRule | undefined;
}

export interface PairedRowProps extends FieldRowProps {
    pairedField: QueryField;
}

export const ruleIdOf = (field: QueryField, rule: QueryRule | undefined): string => rule?.id || field.name;

export const CLEARED_RULE: Partial<QueryRule> = { operator: undefined, value: undefined };
